import styled from 'styled-components';

// Styled component for the message
export const MessageContainer = styled.span`
  background-color: #26762c;
  padding: 2px 6px;
  border-radius: 6px;
  text-align: center;
  color: #fff;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Nunito;
  font-size: 10px;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    padding: 4px 4px 2px 4px;
    font-size: 9px;
  }
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

// Styled component for the wrapper
export const FreeShippingWrapper = styled.div`
  position: absolute;
  width: 100%;
  top: 47px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    top: 40px;
  }
`;
